import { render, staticRenderFns } from "./WidgetPartitionsWatermeters.vue?vue&type=template&id=7f77fffd&scoped=true&"
import script from "./WidgetPartitionsWatermeters.vue?vue&type=script&lang=js&"
export * from "./WidgetPartitionsWatermeters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f77fffd",
  null
  
)

export default component.exports